var map = {
	"./BUY-icon.svg": "0feb",
	"./DEPOSIT-icon.svg": "6652",
	"./Google-Logo.svg": "1480",
	"./LOGIN-icon.svg": "bd21",
	"./LOGOUT-icon.svg": "b713",
	"./Levels/bronze.png": "a542",
	"./Levels/gold.png": "b488",
	"./Levels/silver.png": "26f2",
	"./Levels/vip.png": "d6be",
	"./Logins.svg": "51d6",
	"./Referral/ReferralCode.svg": "3e02",
	"./Referral/ReferralLink.svg": "68fd",
	"./Referral/ReferralStatistics.svg": "69b9",
	"./Referral/friends.svg": "47cd",
	"./Referral/profit.svg": "84a7",
	"./Referral/share-email.svg": "b7b8",
	"./Referral/share-facebook.svg": "5ce5",
	"./Referral/share-instagram.svg": "79b4",
	"./Referral/share-linkedin.svg": "8229",
	"./Referral/share-telegram.svg": "4674",
	"./Referral/share-twitter.svg": "cfe5",
	"./Referral/share-whatsapp.svg": "5c0e",
	"./SELL-icon.svg": "ec73",
	"./Trades.svg": "ca5d",
	"./Transactions.svg": "45c1",
	"./Vector.svg": "93e7",
	"./WITHDRAW-icon.svg": "c16c",
	"./arrow-bottom.svg": "b83a",
	"./arrow-left.svg": "80e5",
	"./arrow-right.svg": "61dc",
	"./bell.svg": "5802",
	"./blog.svg": "714b",
	"./calendar.svg": "dc10",
	"./clock.svg": "5bbf",
	"./close.svg": "0e0a",
	"./coins/BINANCE_COIN.png": "293f",
	"./coins/BITCOIN.png": "4b9f",
	"./coins/BITCOIN_CASH.png": "7735",
	"./coins/CLASSIC_ETHEREUM.png": "33e5",
	"./coins/DASH.png": "f606",
	"./coins/DOGE_COIN.png": "8e5e",
	"./coins/EOS.png": "e79d",
	"./coins/ETHEREUM.png": "d653",
	"./coins/LITE_COIN.png": "e91e",
	"./coins/RIPPLE.png": "4a4a",
	"./coins/STELLAR.png": "b122",
	"./coins/TETHER.png": "ac89",
	"./coins/TOMAN-DARK.svg": "de92",
	"./coins/TOMAN.png": "1d21",
	"./coins/TRON.png": "ad55",
	"./contact-hover.svg": "07a0",
	"./contact-normal.svg": "1c9e",
	"./copy.svg": "07d8",
	"./deposit-modal.png": "a8f2",
	"./faq.svg": "b0f0",
	"./logout.svg": "39e4",
	"./menu-outline.svg": "af71",
	"./menu/advance-market.svg": "3a89",
	"./menu/dashboard.svg": "86c0",
	"./menu/history.svg": "50b0",
	"./menu/invite.svg": "97c3",
	"./menu/main-market.svg": "fc46",
	"./menu/markets.svg": "9595",
	"./menu/setting.svg": "9922",
	"./menu/wallets.svg": "0ce7",
	"./online-chat.svg": "a28a",
	"./trash.svg": "081d",
	"./user.svg": "0a39",
	"./withdraw-modal.png": "d8ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "665f";